import { delay } from "redux-saga/effects";
import fetch from "isomorphic-fetch";

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

// genering request function used by implementor functions. keep this generic, don't split on the action type here
export default function* requestData(action) {
  yield delay(500);

  const response = fetch(action.path, action.options);

  const json = yield response
                     .then(checkStatus)
                     .then(res => res.json())
                     .catch(error => error); // TODO(SI): handle these errors properly.
  return json;
}
